export const uplinkUrgencyList = ["/EXP", "/IMM", "/PD"];
export const uplinkReasonList = ["/TFC", "/RES", "/WX", "/SPC"];
//# sourceMappingURL=uplink.js.map